module.exports = __webpack_public_path__ + "img/demo-photo11.75f1d722.jpg";